<template lang="pug">
AppPopover(
  ref="AppPopover"
  root-class="time-entries-project-switcher-popover"
  :lazy="false"
  @hide="close"
)
  template(#body)
    ValidationObserver(ref="dialogObserver")
      .time-span-popover.time_entry_form
        .row.mb-10
          .col-sm-12.name.strong Reassign time
        TimeEntriesProjectSelect(
          v-model="projectId"
          :project-options="projectSelectOptions"
        )

        TimeEntriesTaskSelect(
          v-if="taskRequiredForTimeEntry"
          v-model="taskId"
          :project-id="projectId"
          :user-id="timeEntry.user_id"
          :required="taskRequiredForTimeEntry"
        )

        TimeEntriesTextarea(
          v-model="note"
          name="note"
          label="Reason"
          placeholder="Why are you adding this time entry? (ex: Forgot to start timer)"
          :required="reasonRequiredForTimeEntry"
        )

        button.btn.btn-success.btn-block.btn-sm(@click="save") Apply

        .curtain(v-show="saving")
          .spinner-wrapper
            span.hi.hi-spinner.hi-32.text-blue
  template(#trigger)
    slot(name="trigger")
  AppConfirm(
    v-if="showProjectBudgetConfirm"
    title="Confirm changes"
    @confirm="save({ allowAboveProjectBudget: true })"
    @cancel="showProjectBudgetConfirm = false"
  )
    | {{ confirmProjectBudgetMessage }}
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash-es';

export default {
  dname: 'TimeEntriesProjectSwitcherPopover',
  props: {
    timeEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      projectId: null,
      taskId: null,
      note: '',
      saving: false,
      showProjectBudgetConfirm: false,
      confirmProjectBudgetMessage: '',
      errorMessage: 'There was an error when updating this time entry',
      successMessage: 'Time entry updated',
    };
  },
  computed: {
    ...mapGetters(['getProject', 'groupedProjects', 'orgProjects']),
    projectSelectOptions() {
      let options = this.orgProjects();

      if (isEmpty(options)) {
        options = this.groupedProjects;
      }

      return options;
    },
    project() {
      return this.getProject(Number(this.projectId));
    },
    taskRequiredForTimeEntry() {
      return this.project ? this.project.tasks_required : false;
    },
    reasonRequiredForTimeEntry() {
      return this.project && this.project.reason_required;
    },
  },
  created() {
    this.reset();
  },
  methods: {
    async save({ allowAboveProjectBudget = false } = {}) {
      const isValid = await this.$refs.dialogObserver.validate();

      if (isValid) {
        const success = this.success;
        const error = () => this.$appMessage(this.errorMessage);
        const fin = () => {
          this.saving = false;
        };

        this.saving = true;
        const params = {
          time_entry: {
            note: this.note,
            project_id: this.projectId,
            task_id: this.taskRequiredForTimeEntry ? this.taskId : null,
            reassign_time: true,
          },
          allow_above_project_budget: allowAboveProjectBudget
        };

        this.$store.dispatch('editTimeEntry', { id: this.timeEntry.id, params }).then(success, error).then(fin);
      }
    },
    success(response) {
      if (response.action === 'error-response') {
        const errors = response.errors;

        this.$refs.dialogObserver.setErrors(errors);
        this.$appMessage(response.alert);
        this.$refs.AppPopover.close();
      } else if (response.action === 'confirm-project-budget') {
        this.showProjectBudgetConfirm = true;
        this.confirmProjectBudgetMessage = response.message;
      } else {
        this.$appMessage(this.successMessage);
        this.$store.dispatch('loadData');
        this.$refs.AppPopover.close();
      }
    },
    reset() {
      this.projectId = this.timeEntry.project_id;
      this.note = '';
      this.showProjectBudgetConfirm = false;
      this.confirmProjectBudgetMessage = '';
      this.saving = false;
      if (this.$refs.dialogObserver) {
        this.$refs.dialogObserver.reset();
      }
    },
    close() {
      this.reset();
    },
  },
};
</script>
